/**
 * What Home looked like on this device last time, so the next visit's loading skeleton (the
 * inline script in index.html reads this key) and Home's first frame take the same shape as the
 * Home that follows: Register and Log in under Quick fight for a guest, the league fight card for a
 * player with a league day ahead.
 */
const KEY = 'caged.boot.v1';

export interface BootHint {
  /** Register and Log in under Quick fight. */
  buttons: boolean;
  /** The league fight card. */
  league: boolean;
}

/** A first visit: a guest's Home. */
export function readBootHint(): BootHint {
  try {
    const hint = JSON.parse(localStorage.getItem(KEY) ?? '{}') as Partial<BootHint> | null;
    return { buttons: hint?.buttons !== false, league: hint?.league === true };
  } catch {
    return { buttons: true, league: false };
  }
}

export function writeBootHint(hint: BootHint): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(hint));
  } catch {
    // No storage: the next visit's skeleton is a guest's.
  }
}
